// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-f3c4ac10] .formulate-input-element {

    display: flex;

    align-items: center;

    border-radius: 12px;

    border-width: 1px;

    border-style: solid;

    --tw-border-opacity: 1;

    border-color: rgb(209 213 219 / var(--tw-border-opacity))
}
[data-v-f3c4ac10] .formulate-input-element--group {

    display: flex;

    flex-direction: column;

    gap: 0.75rem
}
[data-is-showing-errors='true'][data-v-f3c4ac10] .formulate-input-element {

    --tw-border-opacity: 1;

    border-color: rgb(216 0 3 / var(--tw-border-opacity))
}
[data-v-f3c4ac10] .formulate-input-suffix {

    display: flex;

    align-items: center;

    padding-left: 0.5rem;

    padding-right: 0.5rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem;

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
[data-v-f3c4ac10] .formulate-input-errors {

    margin: 0;

    margin-top: 0.5rem;

    list-style-type: none;

    padding: 0;

    --tw-text-opacity: 1;

    color: rgb(216 0 3 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
.formulate-input[data-v-f3c4ac10] input {

    width: 100%;

    border-width: 0px;

    border-style: none;

    padding-left: 0.25rem;

    padding-right: 0.25rem;

    padding-top: 0.75rem;

    padding-bottom: 0.75rem;

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 1rem;

    font-weight: 400
}
.formulate-input[data-v-f3c4ac10] input:focus {

    outline: 2px solid transparent;

    outline-offset: 2px
}
.formulate-input[data-v-f3c4ac10] input:disabled {

    --tw-bg-opacity: 1;

    background-color: rgb(243 244 246 / var(--tw-bg-opacity))
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/inputs/numeric/CurrencyInput.vue"],"names":[],"mappings":";AAyEA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA,sBAAA;;IAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAGA;;IAAA,sBAAA;;IAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,mBAAA;;IAAA,oBAAA;;IAAA,qBAAA;;IAAA,oBAAA;;IAAA,uBAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAGA;;IAAA,SAAA;;IAAA,kBAAA;;IAAA,qBAAA;;IAAA,UAAA;;IAAA,oBAAA;;IAAA,4CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAKA;;IAAA,WAAA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,qBAAA;;IAAA,sBAAA;;IAAA,oBAAA;;IAAA,uBAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,eAAA;;IAAA;AAAA;AAAA;;IAAA,8BAAA;;IAAA;AAAA;AAAA;;IAAA,kBAAA;;IAAA;AAAA","sourcesContent":["<template>\n  <FormulateInput type=\"text\" v-model=\"model\" v-bind=\"$attrs\" inputmode=\"numeric\" @input=\"setValue\">\n    <template #suffix>\n      <div class=\"formulate-input-suffix\">\n        <Icon name=\"input-euro\" :size=\"15\" />\n        {{ suffix }}\n      </div>\n    </template>\n  </FormulateInput>\n</template>\n\n<script>\nimport Icon from '@/lego/components/icons/Icon.vue';\nimport { ref, toRefs, watch } from '@vue/composition-api';\n\nexport default {\n  components: { Icon },\n  props: {\n    value: {\n      type: String | Number,\n    },\n    locale: {\n      type: String,\n      default: 'es-ES',\n    },\n    suffix: {\n      type: String,\n      required: false,\n    },\n    max: {\n      type: Number,\n      default: 20000000,\n    },\n  },\n  setup(props, { root, emit }) {\n    const model = ref(null);\n    const { value } = toRefs(props);\n\n    const setValue = function(v) {\n      var val = parseInt(v?.toString().replace(/[^0-9]/g, ''));\n\n      if (isNaN(val) || val === 0) {\n        model.value = '';\n        emit('input', '');\n\n        return;\n      }\n\n      if (val > props.max) {\n        val = props.max;\n      }\n\n      model.value = val.toLocaleString(props.locale);\n\n      emit('input', val.toString());\n    };\n\n    watch(value, val => setValue(val));\n\n    setValue(value.value);\n\n    return {\n      setValue,\n      model,\n      props,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n/deep/ .formulate-input {\n  &-element {\n    @apply flex items-center border-solid border-hairline border-neutral-semilight rounded-md;\n\n    &--group {\n      @apply flex flex-col gap-micro;\n    }\n    [data-is-showing-errors='true']& {\n      @apply border-feedback-error-medium;\n    }\n  }\n  &-suffix {\n    @apply px-nano py-micro style-body-sm flex items-center;\n  }\n  &-errors {\n    @apply style-overline text-feedback-error-medium mt-nano m-0 p-0 list-none;\n  }\n}\n.formulate-input::v-deep {\n  input {\n    @apply w-full px-quark border-none text-neutral-ultradark py-micro disabled:bg-neutral-lightest style-body-sm focus:outline-none;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
